// Importa script
import './modules/tabs';
import './modules/accordion';
import './modules/professionisti';
import './modules/navigation-mobile';
// import './modules/form-pagina-singola';
import './modules/mappa';
import './modules/scroll-to-anchor';
import './modules/in-view';

document.documentElement.className = document.documentElement.className.replace(/\bno-js\b/, 'js');
